import { Carousel, Container, Image } from 'react-bootstrap';
import ahmetcevdet from '../assets/slider/new/ansiklopedi-slider-ahmet-cevdet.jpg';
import cihangiroglu from '../assets/slider/new/ansiklopedi-slider-cihangiroglu.jpg';
import enginArik from '../assets/slider/new/ansiklopedi-slider-engin-arik.jpg';
import s3 from '../assets/slider/new/ansiklopedi-slider-gaspirali.jpg';
import gelibolu from '../assets/slider/new/ansiklopedi-slider-gelibolu.jpg';
import s4 from '../assets/slider/new/ansiklopedi-slider-karahanlilar.jpg';
import kerkuk from '../assets/slider/new/ansiklopedi-slider-kerkuk.jpg';
import takdim from '../assets/slider/new/ansiklopedi-slider-takdim2.jpg';
import s1 from '../assets/slider/new/ansiklopedi-slider-turk-kultur.jpg';
import tda from '../assets/slider/tda.png';

import asyaHun from '../assets/slider/new2/asya-hun-devleti.jpg';
import betul from '../assets/slider/new2/betul-kacar.jpg';
import dedeKorkut from '../assets/slider/new2/dede-korkut.jpg';
import fatihSultanMehmet from '../assets/slider/new2/fatih-sultan-mehmet.jpg';
import fuzuli from '../assets/slider/new2/fuzuli.jpg';
import halilInalcik from '../assets/slider/new2/halil-inalcik.jpg';
import istanbul from '../assets/slider/new2/istanbul.jpg';
import mimarSinan from '../assets/slider/new2/mimar-sinan.jpg';
import turgutReis from '../assets/slider/new2/turgut-reis.jpg';

import { useNavigate } from 'react-router-dom';
import { getDetailLink } from '../utils/utilFunction';

function MyCarousel({data}) {
  const navigate = useNavigate();
  return (
    <Container> 
        <Carousel data-bs-theme="dark" className='mt-4 mainCarousel'>
            <Carousel.Item onClick={()=>navigate("/mobile")}>
                <Image src={tda} fluid className='w-100' />
            </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate("/hakkinda")}>
            <Image src={takdim} fluid className='w-100' />
        </Carousel.Item>
        {/* 
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:1768 , title : "Türk Dünyası Kültür Coğrafyası"}))}>
            <Image src={s1} fluid className='w-100' />
        </Carousel.Item>
    <Carousel.Item  onClick={()=>navigate(getDetailLink({id:1673 , title : "Ali Bey Hüseyinzade"}))}>
            <Image src={s2} fluid className='w-100' />
        </Carousel.Item> 
     
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:6602 , title : "Asya Hun Devleti"}))}>
            <Image src={s3} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:5097 , title : "Betül Kaçar "}))}>
            <Image src={s4} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:57 , title : "Gelibolu"}))}>
            <Image src={gelibolu} fluid className='w-100' />
        </Carousel.Item>
      <Carousel.Item  onClick={()=>navigate(getDetailLink({id:819 , title : "Nuri Paşa"}))}>
            <Image src={s5} fluid className='w-100' />
        </Carousel.Item> 

        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:1661 , title : "Kerkük"}))}>
            <Image src={kerkuk} fluid className='w-100' />
        </Carousel.Item>

        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:15 , title : "Cihangiroğlu"}))}>
            <Image src={cihangiroglu} fluid className='w-100' />
        </Carousel.Item>

        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:982 , title : "Ahmet Cevdet"}))}>
            <Image src={ahmetcevdet} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:31 , title : "Engin Arık"}))}>
            <Image src={enginArik} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:1716 , title : "Yakut Türkleri"}))}>
            <Image src={yakut} fluid className='w-100' />
        </Carousel.Item>

      {data.map((item,key)=>
           <Carousel.Item key={key} onClick={()=>navigate(getDetailLink(item))}>
           <Image src={s2} fluid className='w-100' />
       </Carousel.Item>
        )} */}


        
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:6602 , title : "Asya Hun Devleti"}))}>
            <Image src={asyaHun} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:20 , title : "Betül Kaçar"}))}>
            <Image src={betul} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:8180 , title : "Dede Korkut"}))}>
            <Image src={dedeKorkut} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:7865 , title : "Fatih Sultan Mehmet"}))}>
            <Image src={fatihSultanMehmet} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:1579 , title : "Fuzuli"}))}>
            <Image src={fuzuli} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:46 , title : "Halil İnalcık"}))}>
            <Image src={halilInalcik} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:843 , title : "İstanbul"}))}>
            <Image src={istanbul} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:1639 , title : "Mimar Sinan"}))}>
            <Image src={mimarSinan} fluid className='w-100' />
        </Carousel.Item>
        <Carousel.Item  onClick={()=>navigate(getDetailLink({id:7782 , title : "Turgut Reis"}))}>
            <Image src={turgutReis} fluid className='w-100' />
        </Carousel.Item>

        {data.map((item,key)=>
           <Carousel.Item key={key} onClick={()=>navigate(getDetailLink(item))}>
           <Image src={item.primaryImage} fluid className='w-100' />
       </Carousel.Item>
        )}

        </Carousel>
    </Container>
  );
}

export default MyCarousel;